<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">

              <!-- Typing Animation Header -->
              <v-row justify="center" class="pb-6 ma-0 pt-8">
                <div class="typing-container pa-0 ma-0">
                  <div class="fonts-head typing-text" id="feature-text">
                    {{ dynamicText }}
                    <span class="cursor"></span>
                  </div>
                </div>
              </v-row>

              <!-- Auth2fa Deactivate Card -->
              <v-row justify="center" class="ma-0">
                <div class="auth2fa-deactivate-card">
                  <v-card class="auth2fa-deactivate-form-card">
                    <v-card-text class="auth2fa-deactivate-form-content">
                      
                      <!-- OTP Input Form -->
                      <v-form ref="formlogin" v-model="validLogin" id="check-login-form">
                        <div class="otp-wrapper">
                          <div class="otp-container">
                            <v-otp-input 
                              v-model="auth2facode" 
                              :disabled="loading" 
                              type="number" 
                              length="6" 
                              color="#1ff050"
                              class="otp-input"
                            ></v-otp-input>
                            
                            <!-- Loading Overlay -->
                            <div v-show="loading" class="otp-loading-overlay">
                              <v-progress-circular indeterminate color="#1ff050" size="48"></v-progress-circular>
                            </div>
                          </div>
                        </div>
                      </v-form>

                      <!-- Countdown Timer -->
                      <v-row justify="center" class="pb-2 pt-4 ma-0">
                        <div class="countdown-container">
                          <v-icon size="18" class="countdown-icon">mdi-timer-outline</v-icon>
                          <span v-if="this.countdown > 1" class="countdown-text">
                            You have {{ countdown }} seconds to enter valid code
                          </span>
                          <span v-if="this.countdown < 2" class="countdown-text">
                            You have {{ countdown }} second to enter valid code
                          </span>
                        </div>
                      </v-row>

                      <!-- Error Attempts -->
                      <v-row v-if="this.errorcount > 0" justify="center" class="pb-2 pt-0 ma-0">
                        <div class="error-attempts-container">
                          <v-icon size="18" class="error-icon">mdi-alert-circle-outline</v-icon>
                          <span v-if="this.errorcount < 2" class="error-attempts-text">
                            You have {{ 3 - this.errorcount }} more attempts left
                          </span>
                          <span v-if="this.errorcount > 1" class="error-attempts-text">
                            You have {{ 3 - this.errorcount }} more attempt left
                          </span>
                        </div>
                      </v-row>

                      <!-- Error Message -->
                      <v-row v-if="this.loginerror !== ''" justify="center" class="pt-0 ma-0 pb-4">
                        <v-alert type="error" density="compact" class="auth2fa-error-alert">
                          <span class="blink">{{ this.loginerror }}</span>
                        </v-alert>
                      </v-row>

                      <!-- Verify Button -->
                      <v-row justify="center" class="pb-4 pt-2 ma-0">
                        <v-btn 
                          type="submit" 
                          form="check-login-form"
                          :disabled="auth2facode.length !== 6 || this.loading" 
                          :loading="loading"
                          color="#000000"
                          variant="outlined"
                          class="verify-btn"
                          size="large"
                          block
                          @click="auth2fa()"
                        >
                          <v-icon v-if="!loading" left>mdi-shield-check</v-icon>
                          <span v-if="!loading">Verify</span>
                          <span v-if="loading">Verifying..</span>
                        </v-btn>
                      </v-row>

                      <!-- Back to Settings Link -->
                      <v-row justify="center" class="pb-2 pa-0 ma-0">
                        <span class="sign-up-text-policy">
                          Back to
                          <span class="link-accept-signup" @click="handleClickMenu('settings')">
                            Settings
                          </span>
                        </span>
                      </v-row>

                    </v-card-text>
                  </v-card>

                  <!-- Footer Links -->
                  <div class="footer-links">
                    <div class="footer-buttons-container">
                      <button 
                        class="footer-link-btn"
                        @click="handleClickMenu('Terms')"
                      >
                        <v-icon size="14" class="footer-link-icon">mdi-file-document-outline</v-icon>
                        <span>Terms of use</span>
                      </button>
                      
                      <div class="separator-dot"></div>
                      
                      <button 
                        class="footer-link-btn"
                        @click="handleClickMenu('Privacy')"
                      >
                        <v-icon size="14" class="footer-link-icon">mdi-shield-lock-outline</v-icon>
                        <span>Privacy policy</span>
                      </button>
                    </div>
                  </div>
                </div>
              </v-row>

            </div>
          </div>
        </div>
        <v-row
          :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important' : 'padding-top:123px!important'"
        ></v-row>
      </div>
    </div>
  </div>
</template>

<script>

import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'

export default {
  name: 'Auth2faDeactivate',

  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    return { isMobile, isMobileXs, isMobilePlayer3 }
  },

  components: {
  },
  data: () => ({
    delay: 80,
    validLogin: false,
    loading: false,

    user: null,
    auth2facode: '',
    loginerror: '',
    errorcount: 0,

    dynamicText: '',
    text: '2FA Deactivation',
    countdown: 120,
    countdownTimer: null,
    navbar: false,
  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
    
    this.typeText(0);
    this.errorcount = 0;
    this.countdown = 120;
    this.loading = false;
    this.startCountdown();

    if (this.$store.getters.getUserData === null) {
      this.$router.push({ name: 'settings' });
    } else {
      this.user = this.$store.getters.getUserData;
      // Check if user has 2fa enabled, if not redirect to settings
      if (this.user['2fa'] !== 1) {
        this.$router.push({ name: 'settings' });
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  destroyed() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  computed: {
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
  },
  created() {
    if (this.$refs.formlogin) {
      this.$refs.formlogin.resetValidation();
    }

    if (window.innerWidth > 768) {
      this.navbar = false;
    } else {
      this.navbar = true;
    }
  },
  methods: {
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    startCountdown() {
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
          this.countdownFinished();
        }
      }, 1000);
    },
    countdownFinished() {
      this.$router.push({ name: 'settings' });
    },
    auth2fa() {
      this.loading = true
      this.validLogin = false;
      this.auth2facode = this.auth2facode.trim()

      this.$store.dispatch('disableauth2fa', {
        code: this.auth2facode,
        token: this.user.token
      }
      ).then(response => {
        this.gotorootdash();
        this.loading = false
      }).catch(error => {
        if (!error.response) {
          this.loginerror = 'Service is down.. Try again later!'
          this.loading = false
          this.auth2facode = ''
        } else {
          this.loading = false
          this.auth2facode = ''
          this.loginerror = '2FA verification failed..'
          this.errorcount += 1;
          if (this.errorcount > 2) {
            this.$router.push({ name: 'settings' });
          }
        }
      });
    },
    gotorootdash() {
      this.$router.push({ name: 'settings' });
    },
    async typeText(num) {
      let i = 0;
      while (i < this.text.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text[i];
        i++;
      }
      await this.waitForMs(2000);
      if (num === 0) {
        this.text = 'Open Authenticator'
        this.dynamicText = '';
        this.typeText(1);
      } else if (num === 1) {
        this.text = 'Read the code'
        this.dynamicText = '';
        this.typeText(2);
      } else {
        await this.waitForMs(4000);
        this.dynamicText = '';
        this.text = 'Enter and verify'
        this.typeText(0)
      }
    },
    waitForMs(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    handleClickMenu(link) {
      if (link === 'Terms') {
        window.open('https://muzible.com/terms', '_blank');
      } else if (link === 'Privacy') {
        window.open('https://muzible.com/privacy', '_blank');
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Body Overall - Removed fixed height for scrolling */
.body-overall {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

/* Typing Animation */
.typing-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.typing-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: white;
  text-align: center;
}

.cursor {
  display: inline-block;
  width: 3px;
  height: 32px;
  background-color: white;
  margin-left: 4px;
  animation: blink 0.6s linear infinite alternate;
}

@keyframes blink {
  0% { opacity: 1; }
  40% { opacity: 1; }
  60% { opacity: 0; }
  100% { opacity: 0; }
}

/* Auth2fa Deactivate Card */
.auth2fa-deactivate-card {
  width: 100%;
  max-width: 500px;
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.auth2fa-deactivate-form-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95)) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}

.auth2fa-deactivate-form-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.auth2fa-deactivate-form-content {
  padding: 32px 24px !important;
}

/* OTP Input */
.otp-wrapper {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.otp-container {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.otp-input :deep(.v-otp-input__content) {
  gap: 12px;
}

.otp-input :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.otp-input :deep(.v-field--focused) {
  border-color: #1ff050 !important;
  box-shadow: 0 0 0 2px rgba(31, 240, 80, 0.2);
}

.otp-input :deep(.v-field__input) {
  color: white !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  text-align: center;
  font-family: "Darker Grotesque", sans-serif !important;
}

.otp-input :deep(.v-field--disabled) {
  opacity: 0.5;
}

/* OTP Loading Overlay */
.otp-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(4px);
}

/* Countdown Container */
.countdown-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.countdown-icon {
  color: rgba(255, 255, 255, 0.7);
}

.countdown-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.8) !important;
  font-weight: 500;
}

/* Error Attempts Container */
.error-attempts-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(227, 66, 52, 0.1);
  border: 1px solid rgba(227, 66, 52, 0.3);
  border-radius: 8px;
}

.error-icon {
  color: #E34234;
}

.error-attempts-text {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 14px !important;
  color: #E34234 !important;
  font-weight: 500;
}

/* Error Alert */
.auth2fa-error-alert {
  width: 100%;
  margin: 0 !important;
}

.auth2fa-error-alert .blink {
  -webkit-animation: blinkError 1.5s infinite both;
  animation: blinkError 1.5s infinite both;
}

@keyframes blinkError {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Verify Button */
.verify-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 24px !important;
  border: 2px solid rgba(31, 240, 80, 0.5) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.1) 0%, rgba(31, 240, 80, 0.05) 100%) !important;
  color: #1ff050 !important;
  transition: all 0.3s ease;
}

.verify-btn:hover:not(:disabled) {
  border-color: rgba(31, 240, 80, 0.8) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.2) 0%, rgba(31, 240, 80, 0.1) 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(31, 240, 80, 0.2);
}

.verify-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.4) !important;
  background: rgba(255, 255, 255, 0.05) !important;
}

/* Back to Settings Link */
.sign-up-text-policy {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  text-align: center;
}

.link-accept-signup {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: #1ff050 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #1ff050 !important;
  text-underline-offset: 4px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.link-accept-signup:hover {
  text-decoration-thickness: 2px !important;
  opacity: 0.8;
}

/* Footer Links */
.footer-links {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.footer-link-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  outline: none;
}

.footer-link-btn:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.footer-link-btn:active {
  transform: translateY(0);
}

.footer-link-icon {
  opacity: 0.8;
}

.separator-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

/* Button Overlay Override */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .typing-text {
    font-size: 24px;
  }

  .cursor {
    height: 24px;
  }

  .auth2fa-deactivate-form-content {
    padding: 24px 20px !important;
  }

  .otp-wrapper {
    padding: 20px 0;
  }

  .otp-input :deep(.v-otp-input__content) {
    gap: 8px;
  }

  .otp-input :deep(.v-field__input) {
    font-size: 20px !important;
  }

  .verify-btn {
    font-size: 16px !important;
    padding: 20px !important;
  }

  .countdown-container,
  .error-attempts-container {
    padding: 10px 16px;
  }

  .countdown-text,
  .error-attempts-text {
    font-size: 13px !important;
  }

  .footer-links {
    margin-top: 24px;
    padding-top: 20px;
  }

  .footer-buttons-container {
    gap: 12px;
  }

  .footer-link-btn {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .typing-text {
    font-size: 20px;
  }

  .cursor {
    height: 20px;
  }

  .auth2fa-deactivate-form-content {
    padding: 20px 16px !important;
  }

  .otp-input :deep(.v-otp-input__content) {
    gap: 6px;
  }

  .otp-input :deep(.v-field__input) {
    font-size: 18px !important;
  }

  .countdown-container,
  .error-attempts-container {
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }

  .footer-buttons-container {
    flex-direction: column;
    gap: 8px;
  }

  .separator-dot {
    display: none;
  }

  .footer-link-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Dark Mode Specific Adjustments */
.overlay-grey-web {
  background: transparent !important;
}

/* Loading State for Button */
.verify-btn :deep(.v-btn__loader) {
  color: #1ff050 !important;
}

/* Accessibility */
.verify-btn:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
}

.link-accept-signup:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
  border-radius: 4px;
}

.footer-link-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

/* OTP Input Focus */
.otp-input :deep(.v-field:focus-within) {
  transform: scale(1.02);
}

</style>